/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { setFinanceRefundStatus } from '@/api/financial-center'
import {getMessageRemindById, getMessageReviewById, setMessageReviewUserByMessageReviewId} from '@/api/message'
import { UserModule } from '@/store/modules/user'

@Component({})
export default class RefundInfo extends Vue {
    logShow = true
    refundId = NaN
    refundInfo = null
    status = 1
    type = ''
    cancleReview = false
    reviewDialog = false
    opinion = '' // 审批意见
    reviewStatus: string = null //审批状态
    departmentId = NaN
    fileList: { name: string; url: string; uid?: number }[] = []
    editFileList = []
    editFiles = {
        account: null,
        price: null,
        refundAt: null,
        refundCause: null,
        financeRefundProofList: null,
    }
    isRequired = false
    messageReviewLogList = []
    types = ''
    financeRefundAccount = {}
    financeRefundAccountType = ''

    get userId() {
        return UserModule.userId
    }
    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }
    get elImageUrls() {
        return this.refundInfo ? this.refundInfo.financeRefundProofList.map(item => item.url) : []
    }
    fileExtension(type) {
        return type.substring(type.lastIndexOf('.') + 1)
    }

    created() {
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMsgData(recordId)

    }

    formatDate = formatDate

    async getMsgData(id) {
        const data: any = await getMessageRemindById({id: id})
        this.refundInfo = data.result.messageRemindInfo
        this.editFileList = data.result.messageRemindInfo.editFileList
        this.editFiles.account = this.refundInfo.account
        this.editFiles.price = this.refundInfo.price
        this.editFiles.refundAt = this.refundInfo.refundAt
        this.editFiles.refundCause = this.refundInfo.refundCause
        this.editFiles.financeRefundProofList = this.refundInfo.financeRefundProofList
        if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
        this.financeRefundAccount = this.refundInfo.financeRefundAccount
        this.financeRefundAccountType = (this.financeRefundAccount as any).type
        this.$nextTick(() => {
            this.messageReviewLogList = this.refundInfo.financeRefundLogList
        })
    }
    async getFinanceRefundById() {
        const data: any = await getMessageReviewById(this.refundId,this.types)
        this.refundInfo = data.result
        this.editFileList = data.result.editFileList
        this.editFiles.account = this.refundInfo.account
        this.editFiles.price = this.refundInfo.price
        this.editFiles.refundAt = this.refundInfo.refundAt
        this.editFiles.refundCause = this.refundInfo.refundCause
        this.editFiles.financeRefundProofList = this.refundInfo.financeRefundProofList
        if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
        this.$nextTick(() => {
            this.messageReviewLogList = this.refundInfo.messageReviewLogList
        })
    }

    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.reviewStatus !== '0' || this.type !== '0') return false
        return this.editFileList.some(item => item.file === key)
    }

    openReviewDialog(status: number) {
        this.status = status
        this.reviewDialog = true
    }

    async cancleReviewDialogConfirm() {
        await setFinanceRefundStatus({
            id: this.refundInfo.id,
            action: '1',
        })
        this.$message.success(`成功撤回审批`)
        setTimeout(() => { window.close() }, 1500)
    }

    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }

    reviewDialogConfirm() {
        const newObj = this.editFiles
        for(const key in newObj) {
            if(!this.editFileList.some(item => item.file === key)) delete newObj[key]
        }
        newObj.financeRefundProofList = this.fileList
        if(this.isRequired) {
            let bol = false
            for(const key in newObj) {
                if(!newObj[key] || newObj[key].length === 0) {
                    bol = true
                    break;
                }
            }
            if(bol) {
                this.$message.error('请将编辑的信息填写完整')
                return
            }
        }
        const obj = {
            messageReviewId: this.refundId,
            status: this.status,
            opinion: this.opinion,
            addData: this.fileList,
            form: this.status === 1 ? newObj : {}
        }
        // 69 是财务部门的id
        if(this.departmentId !== 69) delete obj.addData
        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(this.status === 1 ? '审批通过' : '审批驳回')
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            console.log(err)
        })
    }

    uploadSuccess(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.fileList.push({ name: data.name, url: data.ossUrl })
    }
    uploadError() {
        this.$message.error('上传失败')
    }
    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }

}
